import React from "react";
import { useLeafletContext } from '@react-leaflet/core'
import L, { bounds } from 'leaflet'
import { useEffect, useRef, useState } from 'react'
import { MapContainer, TileLayer, useMap, Marker, FeatureGroup, LayerGroup, LayersControl, Popup, Circle, Rectangle } from "react-leaflet";
import {  Button, Table ,Label,Row,Col,Card,CardBody,Input,CardHeader} from "reactstrap"
import {

    Button as ButtonMaterial,
  
  } from "@mui/material";
import MarkerClusterGroup from 'react-leaflet-cluster'
import { Modal,Spinner } from "react-bootstrap";
import { useGtSaathiAprrovalbyIdMutation ,useGtPointCreateBoundaryMutation} from "./RiskManagementApiSlice";
import {  useSelector } from "react-redux";
import {
    selectCurrentUser,
  } from "features/auth/authSlice";
import 'leaflet/dist/leaflet.css';
import swal from "sweetalert"
import { toast } from "react-toastify";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
import RiskManagementGtPointDetailViewPolygonMap from "./RiskManagementGtPointDetailViewPolygonMap";
import RiskManagementGtPointCreateBoundary from "./RiskManagementGtPointCreateBoundary";
import RiskManagementGtPointDetailViewLatLongMap from "./RiskManagementGtPointDetailViewLatLongMap";
import NoEditingGtPoint from "./NoEditingGtPoint";

const markerIcon = new L.Icon({
    iconUrl: require("./marker.png"),
    iconSize: [40, 40],
    iconAnchor: [17, 46], //[left/right, top/bottom]
    popupAnchor: [0, -46], //[left/right, top/bottom]
})

const markerIcon2 = new L.Icon({
    iconUrl: require("./marker8.png"),
    iconSize: [40, 40],
    iconAnchor: [17, 46], //[left/right, top/bottom]
    popupAnchor: [0, -46], //[left/right, top/bottom]

})
function getBounds(props) {
    return L.latLng(props.center).toBounds(props.size)
}

function Square(props) {
    const context = useLeafletContext()
    const squareRef = useRef()
    const propsRef = useRef(props)

    useEffect(() => {

        squareRef.current = new L.Rectangle(getBounds(props))
        const container = context.layerContainer || context.map
        container.addLayer(squareRef.current)

        return () => {
            container.removeLayer(squareRef.current)
        }
    }, [])

    useEffect(() => {
        if (
            props.center !== propsRef.current.center ||
            props.size !== propsRef.current.size
        ) {
            squareRef.current.setBounds(getBounds(props))
        }
        if (props.bounds.length > 1){
            context.map.fitBounds(props.bounds)
        }
        propsRef.current = props
        
    }, [props.center, props.size, props.bounds])

    return null
}

function RiskManagementGtPointMap({GtPointSurvey,latlongData,refetch}) {
     const [center, setCenter] = useState([28.576592977786234, 77.31433377113422])
 
     const [plots, setPLots] = useState([])
     const [gtAllData, setFullGtPoints] = useState([])
     const [show, setShow] = useState(false);
     const currentUser = useSelector(selectCurrentUser);

    //  const RoleAcessParams = ["UPDASP-PM"]
    const RoleAcessParams = currentUser.groups


     const [cardName, setCardValue] = useState("Details")
     const [cropdata,setDetailList]=useState([])
   
     const [cropdataFertilizer,setDetailFertilizerList]=useState([])
     const [cropdataIrrigation,setDetailIrrigationList]=useState([])
     const [updateList, updateFarmResponse] = useGtPointCreateBoundaryMutation()

 
     const [openLightbox, setOpenLightBox] = useState(false);
     const [lightBoxViewImage, setImageInLightbox] = useState("");
     const [remarks, setRemarks] = useState("");
     const [updateQrProcess ] = useGtSaathiAprrovalbyIdMutation();
     const [editAllowed,setEditAllowed]=useState(false)
     const[editableFields,setEditableInputFields]=useState({
         CropName:"",
         CropVariety:"",
         PestiscideName:"",
         Remarks:""
 
     })
     const [disableButton,setdisableSubmitBtn]=useState(false)
     const handleActiveCard = (cardName) => {
        setCardValue(cardName)
      }
    

 
     useEffect(() => {
         const tempPlots = []
         const newPLots=[]
         latlongData.map((plot) => {
             if(Array.isArray(plot))
             {
             if(plot.length>0){
             if(plot[0].lat&&plot[0].long){
             tempPlots.push([plot[0].lat, plot[0].long])
             }
            }
           
             }
         })
     
         setPLots(tempPlots)
         GtPointSurvey.map((item)=>{
          if(item?.LatLong?.length>0){
            newPLots.push(item)
          }
         })
         setFullGtPoints(newPLots)
         
     }, [latlongData,GtPointSurvey])
    // console.log("gtAllData",gtAllData)
   
      const handleShow=(list)=>{
        setDetailList(list)
        setShow(true)
        if( Array.isArray(list?.Fertilizers)){
        setDetailFertilizerList(list?.Fertilizers)
        }
        if( Array.isArray(list?.IrrigationInterval)){
            setDetailIrrigationList(list?.IrrigationInterval)
            }
        
        setEditableInputFields({
            CropName:list.cropName,
            CropVariety:list.cropVariety,
            PestiscideName:list.PestiscideName,
            Remarks:list.OtherRemark
        })
    }
    
      const handleClose = (val) => {
        setShow(val)
        setCardValue("Details")
    
        setEditAllowed(false)
    
    
      };
      const handleLightBoxImage=(image)=>{
        setImageInLightbox(image)
        setOpenLightBox(true)
      }
      const handleRemarks = (event) => {
        setRemarks(event.target.value);
      };
    
      const handleApproveReject = (val) => {
       
        if (remarks === "") {
          swal("Remarks is mendatory !!", {
            buttons: false,
            icon: "warning",
            title: "Please Enter Remark",
            timer: 1500,
          });
        } else {
            let action=""
            if(val==="approve")
            {
                action={
                    action: "qc1_approved",
                    qc_remark: remarks
                }
            }
            if(val==="reject")
            {
                action={
                    action: "qc1_rejected",
                    qc_remark: remarks
                }
            }
            let id=cropdata.Id
            updateQrProcess({ id, action }).then((response) => {
            if (response.data){
              swal("Success", {
                buttons: false,
                icon: "success",
                title: response.data.message,
                timer: 1500,
              });
              setRemarks("")
              refetch()
              setShow(false)
    
            }
            else if (response.error){
              swal("Error", {
                buttons: false,
                icon: "warning",
                title: response.error.data.message,
                timer: 3000,
              });
            }
          }).catch((error) => {
            console.log("catch", error)
          });
        }
      };
    
    
     const handleEditAllow=()=>{
        setEditAllowed(true)
        setdisableSubmitBtn(false)
     }
    const handleSaveAllow=(e)=>{
        e.preventDefault()
        setEditAllowed(false)
        setdisableSubmitBtn(true)
        updateList({ id: cropdata.Id, payload: editableFields })
        .unwrap()
        .then((data) => {
            swal("Fields Updated", {
                buttons: false,
                icon: "success",
                title: "Successfully Updated ",
                timer: 1500,
            })
            handleClose(false)
            setdisableSubmitBtn(false)
    
            refetch()
    
        })
        .catch((error) => {
            toast.error("Error while Updating ")
            setdisableSubmitBtn(false)
    
            return
        })
    
    }
    const handleInputChange=(e)=>{
        setEditableInputFields({
            ...editableFields,
            [e.target.name]:e.target.value
        })
    }
 
     return (
         <>
             <MapContainer center={center} style={{ height: "50vh" ,zIndex:0}} zoom={13}>
                 <TileLayer
                     url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
                     attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                 />
                 <Square center={center} size={0} bounds={plots} />
                         <MarkerClusterGroup
                             chunkedLoading
                         >
                             {
                                gtAllData?.map((item,index) => {
                          return(
                                <p key={index}>
                                <Marker
                                position={[
                                            item?.LatLong[0].lat,
                                           item?.LatLong[0].long,
                                          ]}
                                  icon={markerIcon}
                                >
                                
                                <Popup>
                                <Table className="table mb-0">
                                  <tbody>
                                  <tr>
                                  <th>Name: </th>
                                  <td>{item.FarmerName}</td>
                                </tr>
                                  <tr>
                                  <th>Survey No: </th>
                                  <td>{item.SurveyNo}</td>
                                </tr>
                                <tr>
                                <th>Crop Name: </th>
                                <td>{item.CropName}</td>
                              </tr>
                              <tr>
                              <th>Crop Variety: </th>
                              <td>{item.CropVariety}</td>
                            </tr>
                              <tr>
                              <th>Crop Id: </th>
                              <td>{item.CropId}</td>
                            </tr>
                          
                         
                        
                          
                         
                                  </tbody>
                                  
                                </Table>
                                <Row>
                                <ButtonMaterial
                                variant="contained"
                                color="success"
                                className=" mt-3"
                                onClick={() => handleShow(item)}

                              >
                                View Details
                               
                              </ButtonMaterial>
                              </Row>
                               
                              </Popup>
                              
                                
                                </Marker>
                                       
                           
                          </p>
                          )
                             })
                            }
                         </MarkerClusterGroup>
             </MapContainer>
             <Modal show={show} onHide={()=>handleClose(false)}
             dialogClassName="modal-90w"
             aria-labelledby="example-custom-modal-styling-title"
             size="xl"
             style={{ marginTop: "" }}
           >
             <Modal.Header closeButton style={{ marginTop: "" }}>
               <Modal.Title>Details</Modal.Title>
             </Modal.Header>
             <Modal.Body>
             {currentUser?.realm_access?.roles.includes("HCL")?
            <NoEditingGtPoint cardName={cardName} RoleAcessParams={currentUser?.realm_access?.roles} cropdata={cropdata} refetch={refetch} handleClose={()=>handleClose(false)} cropdataLatLong="" cropdataFertilizer={cropdataFertilizer} cropdataIrrigation={cropdataIrrigation}/>
            :
    
               <Row><Col lg="1"></Col>

                 <div className="">
                 {RoleAcessParams.includes("UPDASP-PM")?"":
                   <div className="radio-inputs text-center" style={{ width: "45%",margin:"auto" }} >

                   <label className="radio">

                     <div onClick={() => handleActiveCard("Details")} >
                       <input type="radio" name="radio" defaultChecked />
                       <h4 className="name2  m-0">Details</h4>
                     </div>
                   </label>
                          
                          
                   <label className="radio">
                     <div onClick={() => handleActiveCard("Documents")}>
                       <input type="radio" name="radio" />
                       <h4 className="name2 text-primary m-0">Documents</h4>
                     </div>
                   </label>
                   {RoleAcessParams.includes("UPDASP-PM")? "":

                   <label className="radio">
                   <div onClick={() => handleActiveCard("Geo Tag")}>
                     <input type="radio" name="radio" />
                     <h4 className="name2 text-primary m-0">Geo Tag</h4>
                   </div>
                 </label>
                          }
                 </div>
                        }
                 {cardName === "Details" ?
                 <>
                 {RoleAcessParams.includes("UPDASP-PM")? "":

                 <Card>
                 <CardBody>
                 <Row className="">
                 {RoleAcessParams.includes("UPDASP-PM")? "":

                 <Col lg="1" className="offset-md-11 ">
                 {editAllowed?
                   <ButtonMaterial
                   variant="contained"
                   color="success"
                   className="mx-3 mt-1"
                 onClick={handleSaveAllow}
                 >
                   SAVE
                   {disableButton ?
                       <Spinner animation="border" size="sm" />
                       : ""
                   }
                 </ButtonMaterial>
               :
                 <ButtonMaterial
                 variant="contained"
                 color="primary"
                 className="mx-3 mt-1"
               onClick={handleEditAllow}
               >
                 Edit
               </ButtonMaterial>
                 }
                 
                 </Col>
                }
               
                 <Col lg="3" className="mb-2">
                   <Label>Crop Name</Label>
                   <Input
                     type="text"
                     name="CropName"
                     className="f400"
                   disabled={editAllowed?false:true}
                     id=""
                     defaultValue={
                       cropdata?.CropName}
                       onChange={handleInputChange}
                     
                   />
                 </Col>
                 <Col lg="3" className="mb-2">
                   <Label>Crop Variety</Label>
                   <Input
                     type="text"
                     name="CropVariety"
                     id=""
                     defaultValue={cropdata?.CropVariety}
                     className="f400"
                     disabled={editAllowed?false:true}
                     onChange={handleInputChange}
   
                    
                     
                   />
                 </Col>
                 <Col lg="3" className="mb-3">
                 <Label>Crop Stage</Label>
                 <Input
                   type="text"
                   name="StressReason"
                   id=""
                   defaultValue={cropdata?.CropStage}
                    className="f400"
                   disabled
                 />
               </Col>
                 <Col lg="3" className="mb-2">
                   <Label>Pesticide Name</Label>
                   <Input
                     type="text"
                     name="PestiscideName"
                     id=""
                     defaultValue={cropdata?.PestiscideName}
                     className="f400"
                     disabled={editAllowed?false:true}
   
                     onChange={handleInputChange}
   
                     
                   />
                 </Col>
               
                 <Col lg="3" className="mb-3">
                   <Label>Soil Moisture</Label>
                   <Input
                     type="text"
                     name="VarietyName"
                     id=""
                     defaultValue={cropdata?.SoilMoisture}
                     className="f400"
   
                     disabled
                   />
                 </Col>
                 <Col lg="3" className="mb-3">
                   <Label>Sowing Date</Label>
                   <Input
                     type="text"
                     name="IsIrrigated"
                     id=""
                     defaultValue={cropdata?.SowingDate}
                     className="f400"
   
                     disabled
                   />
                 </Col>
                 <Col lg="3" className="mb-3">
                   <Label>Remarks</Label>
                   <Input
                     type="text"
                     name="Remarks"
                     id=""
                     defaultValue={cropdata?.OtherRemark}
                     className="f400"
                     disabled={editAllowed?false:true}
                     onChange={handleInputChange}
   
   
                     
                   />
                 </Col>
                 <Col lg="3" className="mb-3">
                   <Label>Last Year Yield</Label>
                   <Input
                     type="text"
                     name="IrrigationCount"
                     id=""
                     defaultValue={cropdata?.LastYearYield}
                     className="f400"
   
                     disabled
                   />
                 </Col>
   
                 <Col lg="3" className="mb-3">
                   <Label>Is Disease Attack</Label>
                   <Input
                     type="text"
                     name="IsPestiscide"
                     id=""
                     defaultValue={cropdata?.IsDiseaseAndPestAttack?"Yes":"No"}
                     className="f400"
   
                     disabled
                   />
                 </Col>
              
                 <Col lg="3" className="mb-3">
                   <Label>Is Irrigated</Label>
                   <Input
                     type="text"
                     name="AnyStress"
                     id=""
                     defaultValue={cropdata?.IsIrrigated?"Yes":"No"}
                     className="f400"
   
                     disabled
                   />
                 </Col>
                 <Col lg="3" className="mb-3">
                 <Label>Irrigation Source</Label>
                 <Input
                   type="text"
                   name="StressReason"
                   id=""
                   defaultValue={cropdata?.IrrigationSource}
                   className="f400"
   
                   disabled
                 />
               </Col>
              
               
               <Col lg="3" className="mb-3">
               <Label>Fertilizer Type</Label>
               <Input
                 type="text"
                 name="StressReason"
                 id=""
                 defaultValue={cropdata?.FertilizerType}
                  className="f400"
                 disabled
               />
             </Col>
            
               </Row>
               {cropdataFertilizer.length>0?
                   <>
               <h5 className="my-3 p-3 bg-secondary3">Fertilizers </h5>
               <Row>
               <Col lg="3" className="mb-3">
               <Label>&nbsp;Name</Label></Col>
               <Col lg="3" className="mb-3">
               <Label>&nbsp;Quantity</Label></Col>
               </Row>
                 {cropdataFertilizer?.map((item)=>{
                   return(
                       <Row>
                   <Col lg="3" className="mb-3">
                   <Input
                     type="text"
                     name="StressReason"
                     id=""
                     defaultValue={item?.name}
                     className="f400"
   
                     disabled
                   />
                 </Col>
                 <Col lg="3" className="mb-3">
                 <Input
                   type="text"
                   name="StressReason"
                   id=""
                   defaultValue={item?.quantity}
                   className="f400"
   
                   disabled
                 />
               </Col>
                 </Row>
                 )
                 })}
               
                 
                 
                 </>
                 :""}
                   
               <h5 className="my-3 p-3 bg-secondary3">Irrigation </h5>
   
               <Row>
               <div>&nbsp; Irrigation Count : <span className="text-success f400">{cropdata?.IrrigationCount}</span></div>
               {cropdataIrrigation?.length>0?
                   <>
               <div className="mt-3 "> &nbsp;&nbsp;Irrigation Value :</div>
   
               <div className="d-flex mx-2">
              
              
             
                 {cropdataIrrigation?.map((item,index)=>{
                   return(
                         <li className="mt-3 mx-4 f400  textlistHide">
              <span className=" f400 text-black">{index+1}<span class="mdi mdi-chevron-right"></span>
              </span> <span  className="text-success f400">{item?.name}</span>
              
                 </li>
                 )
                 })}
                 </div>
                 </>
                 :""}
                 
                 
                 </Row>
                
               </CardBody>
               </Card>
                }
                {RoleAcessParams.includes("UPDASP-PM")? 
                <Card>
                      <CardHeader className="mt-2">Documents</CardHeader>
                <Row>
     
                {cropdata ?
                
    
                  <Row>
    
                    {
                      cropdata?.Media ?
                      cropdata?.Media?.map((list, index) =>
                          list.ImagePath !== "" ? (
                            <Col lg={3} key={list.index} className="mt-3"  >
                              <Card className="text-center border ">
                                <CardBody>
                                  <div className="img-fluid float-left">
                                    <p className="mb-1 text-uppercase">{list.Attribute}</p>
                                    <hr className="mt-2" />
    
                                   
    
                                    {list.ImagePath.includes("mp4") ?
                                      <video width="320" height="240" controls>
                                        <source src={list.ImagePath} type="video/mp4" />
                                        <source src={list.ImagePath} type="video/ogg" />
                                      </video>
    
                                      : list.ImagePath.includes("pdf") ?
    
                                        <object data={list.ImagePath}
                                          type='application/pdf'
                                          width='100%'
                                          height='400px' />
    
    
    
                                        :
                                        
                                        <img src={list.ImagePath}
                                         onClick={()=>handleLightBoxImage(list.ImagePath)}
    
                                          alt=""
                                          className="img-fluid cursor-pointer"
                                        />
                                       
                                      
    
                                    }
                                    <hr className="mt-2" />
    
                                    <p className="mb-1 text-uppercase">Accuracy : {list.Metadata?list.Metadata.Accuracy:""}</p>
                                    <p className="mb-1 text-uppercase">Azimuth : {list.Metadata?list.Metadata.azimuth:""}</p>
                                    <p className="mb-1 text-uppercase">Elevation :{list.Metadata?list.Metadata.Elevation:""}</p>
                                    
                                    {openLightbox?
                                      <Lightbox image={lightBoxViewImage} title="Image Title" onClose={() => setOpenLightBox(false)}/>
                                    :""}
                                  </div>
                                </CardBody>
    
                              </Card>
                            </Col>
                          ) : null
                        )
                        : ""
                    }
    
                  </Row>
                  : null}
              </Row>
              </Card>
              :""}
               <Row>
               
               <Card className="mt-3">
               <CardHeader className="mt-2">Boundary</CardHeader>
                <CardBody>
                  {JSON.stringify(cropdata.FarmBoundaryVerified) !== `{}`?
                <RiskManagementGtPointDetailViewPolygonMap farmerBoundary={cropdata.FarmBoundaryVerified}/>
                 :JSON.stringify(cropdata.FarmBoundaryVerified) === `{}`&&JSON.stringify(cropdata.FarmBoundaryTagging) === `{}`?
                 <RiskManagementGtPointDetailViewLatLongMap latLongData={cropdata.LatLong}/>
                 :<RiskManagementGtPointDetailViewPolygonMap farmerBoundary={cropdata.FarmBoundaryTagging}/>
   
               }
                </CardBody>
               </Card>
              
              </Row>
            

























              {RoleAcessParams.includes("developer")||RoleAcessParams.includes("admin")||RoleAcessParams.includes("State Head")||RoleAcessParams.includes("Checker")?
              <Row>
              <Card>
              <CardBody className="p-2">
              <Col className="col-lg-12 mb-2 ">
                  <h6 className="my-3 p-3 bg-secondary3"> Take Action <span className="float-end"> Status : <span className="text-success f400">{cropdata?.QCType}</span> </span> </h6>
                  <form className="needs-validation">
                      <Col lg="12" className="mb-2">
                          <Label>Remarks*</Label>
                        
                              <Input
                                  className=""
                                  type="textarea"
                                  id="textarea"
                                  name="remarks"
                                  placeholder="Please Enter Remark"
                                  value={remarks}
                                  onChange={handleRemarks}
                                  required
                              />
                         
                      </Col>
                      <Col className="text-center">
                         
                          <ButtonMaterial
                          variant="contained"
                          color="success"
                          className="mx-3 mt-3"
                          onClick={() => handleApproveReject("approve")}
                          disabled={cropdata?.QCType==="QC1 Approved" || cropdata?.QCType==="QC1 Rejected"?true:false}
                        >
                          Approve 
                        </ButtonMaterial>
   
                        <ButtonMaterial
                        variant="contained"
                        color="error"
                        className="mx-3 mt-3"
                        onClick={() => handleApproveReject("reject")}
                        disabled={cropdata?.QCType==="QC1 Approved" || cropdata?.QCType==="QC1 Rejected"?true:false}
   
   
                      >
                      Reject 
                      </ButtonMaterial>
   
   
   
                         
                      </Col>
   
                  </form>
              </Col>
              </CardBody>
              </Card>
          </Row>
            :""}
   
   
   
   
   
   
   
   
               </>
               : cardName==="Documents"?
               <Row>
   
               {cropdata ?
               
   
                 <Row>
   
                   {
                     cropdata?.Media ?
                     cropdata?.Media?.map((list, index) =>
                         list.ImagePath !== "" ? (
                           <Col lg={3} key={list.index} className="mt-3"  >
                             <Card className="text-center border ">
                               <CardBody>
                                 <div className="img-fluid float-left">
                                   <p className="mb-1 text-uppercase">{list.Attribute}</p>
                                   <hr className="mt-2" />
   
                                  
   
                                   {list.ImagePath.includes("mp4") ?
                                     <video width="320" height="240" controls>
                                       <source src={list.ImagePath} type="video/mp4" />
                                       <source src={list.ImagePath} type="video/ogg" />
                                     </video>
   
                                     : list.ImagePath.includes("pdf") ?
   
                                       <object data={list.ImagePath}
                                         type='application/pdf'
                                         width='100%'
                                         height='400px' />
   
   
   
                                       :
                                       
                                       <img src={list.ImagePath}
                                        onClick={()=>handleLightBoxImage(list.ImagePath)}
   
                                         alt=""
                                         className="img-fluid cursor-pointer"
                                       />
                                      
                                     
   
                                   }
                                   <hr className="mt-2" />
   
                                   <p className="mb-1 text-uppercase">Accuracy : {list.Metadata?list.Metadata.Accuracy:""}</p>
                                   <p className="mb-1 text-uppercase">Azimuth : {list.Metadata?list.Metadata.azimuth:""}</p>
                                   <p className="mb-1 text-uppercase">Elevation :{list.Metadata?list.Metadata.Elevation:""}</p>
                                   
                                   {openLightbox?
                                     <Lightbox image={lightBoxViewImage} title="Image Title" onClose={() => setOpenLightBox(false)}/>
                                   :""}
                                 </div>
                               </CardBody>
   
                             </Card>
                           </Col>
                         ) : null
                       )
                       : ""
                   }
   
                 </Row>
                 : null}
             </Row>
               : <RiskManagementGtPointCreateBoundary latLongData={cropdata.LatLong} listData={cropdata} refetch={refetch} handleClose={handleClose}/>
           }
                 </div>
               </Row>
}
             </Modal.Body>
             <Modal.Footer>
               <Button variant="secondary" onClick={()=>handleClose(false)}>
                 Close
               </Button>
   
             </Modal.Footer>
           </Modal>
         </>
     )
 }

export default RiskManagementGtPointMap;
